var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 1.5H14.4852V11.6316H9.41943L4.35363 14.1645V11.6316H1.1875V1.5ZM4.35363 6.5658H4.98685V7.19903H4.35363V6.5658ZM7.51975 6.5658H8.15298V7.19903H7.51975V6.5658ZM10.6859 6.5658H11.3191V7.19903H10.6859V6.5658Z",
    stroke: "#737791",
    strokeWidth: 1.26645
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.3fc757913930c8eff393823b61c8c3d8.svg";
export { ForwardRef as ReactComponent };